/**
 * This module returns a common Menu modules store to be used in all Components.
 */
import storeBuilder from 'reduxStore/store';

// Create the instance and export it
export default storeBuilder();
